class ProductGridViewToggle extends HTMLElement {
  constructor() {
    super();
    this.productGrid = null;
  }

  connectedCallback() {
    this.render();
    this.init();
  }

  render() {
    this.productGrid = this.querySelector(".product-grid");
  }

  init() {
    if (this.productGrid) {
      // Setup event listeners for buttons
      const toggleButtons = this.querySelectorAll("[data-toggle-view]");
      toggleButtons.forEach((button) => {
        button.addEventListener("click", (event) => this.toggleView(event));
      });
    } else {
      console.error("Product grid element not found.");
    }
  }

  toggleView(event) {
    const view = event.currentTarget.dataset.toggleView; // Using dataset instead of getAttribute

    // Update the productGrid class based on the selected view
    if (view === "column") {
      this.setColumnView();
    } else if (view === "row") {
      this.setRowView();
    }
  }

  setColumnView() {
    this.productGrid.classList.add("column-view");
    this.productGrid.classList.remove("row-view");
    this.updateActiveButtons("column");
    this.updateCartAttributes("column");
  }

  setRowView() {
    this.productGrid.classList.add("row-view");
    this.productGrid.classList.remove("column-view");
    this.updateActiveButtons("row");
    this.updateCartAttributes("row");
  }

  updateActiveButtons(activeView) {
    const toggleButtons = this.querySelectorAll("[data-toggle-view]");
    toggleButtons.forEach((button) => {
      if (button.dataset.toggleView === activeView) {
        button.classList.add("active");
      } else {
        button.classList.remove("active");
      }
    });
  }

  updateCartAttributes(view) {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        attributes: {
          productGridView: view, // Save the selected view as a cart attribute
        },
      }),
    })
      .then((response) => {
        if (response.ok) {
          console.log("Cart attributes updated successfully");
        } else {
          console.error("Failed to update cart attributes");
        }
      })
      .catch((error) => {
        console.error("Error updating cart attributes:", error);
      });
  }

  disconnectedCallback() {
    // Clean up event listeners
    const toggleButtons = this.querySelectorAll("[data-toggle-view]");
    toggleButtons.forEach((button) => {
      button.removeEventListener("click", this.toggleView);
    });
  }
}

// Define the custom element
customElements.define("product-grid-view", ProductGridViewToggle);
